import { useWinController } from "./useWinController";
import { useFreeSpinWinController } from "./useFreeSpinWinController";
import { useFreeSpinBasicWinController } from "./useFreeSpinBasicWinController";
import { useHoldAndWinCollectionController } from "./useHoldAndWinCollectionController";

/**
 * The win controllers, mounted once for the session.
 *
 * Two free-spin entries, and they are not the same thing:
 *
 *   useFreeSpinWinController       Zeus's mask-reveal board. Driven by the
 *                                  SINGULAR featureGame flags, which nothing
 *                                  in Mad Labs sets — so it is inert here.
 *   useFreeSpinBasicWinController  the Mad Labs bonus board. A copy of the
 *                                  current useWinController on the bonus
 *                                  room's own refs and its own round.
 *
 * Each watches a different board, so mounting all of them is not a conflict:
 * only the one whose round is running has anything to animate.
 */
const HookImport = () => {
  useWinController();
  useFreeSpinWinController();
  useFreeSpinBasicWinController();
  useHoldAndWinCollectionController();
  return null;
};

export default HookImport;
